import ModuleMultiSelect from './ModuleMultiSelect';

export default class NAICSCodeSelect extends ModuleMultiSelect
{
	Type = 'NAICS';
};

